import { useCreate } from "../../../../api/react-query"

export const useUploadDocument = ({disable} = {}) => {
    const {mutateAsync, isLoading, isError} = useCreate({
        url: 'file/upload',
        disableToast: disable
    });

    return {
        uploadDocument : mutateAsync,
        isUploading : isLoading,
        error: isError
    }
};
